import axios from 'axios';
import { logout } from "../../actions/auth";
import { safeApiRoot } from "../tenant-domain";

const normalizeRoot = (url) => {
  const value = String(url || '').trim().replace(/^['"]+|['";]+$/g, '').trim();
  if (!value) return '/';
  if (value.startsWith('/')) return value.endsWith('/') ? value : `${value}/`;

  return safeApiRoot(value);
};

const apiBase = () => {
  const root = normalizeRoot(localStorage.api).replace(/\/+$/, '');
  if (root.endsWith('/api') || root.endsWith('/api/v1')) return root;
  return `${root}/api`;
};

const api = axios.create({
  baseURL: apiBase()
});

const isFormDataPayload = (data) => typeof FormData !== "undefined" && data instanceof FormData;

const clearContentType = (headers) => {
  if (!headers) return;

  if (typeof headers.delete === "function") {
    headers.delete("Content-Type");
    headers.delete("content-type");
    return;
  }

  delete headers["Content-Type"];
  delete headers["content-type"];
};

api.interceptors.request.use(
  cfg => {
    cfg.baseURL = apiBase();
    if (isFormDataPayload(cfg.data)) clearContentType(cfg.headers);
    if (localStorage.token) cfg.headers['x-auth-token'] = localStorage.token;
    if (localStorage.instance) cfg.headers['instance'] = localStorage.instance;
    return cfg;
  },
  err => {
    return Promise.reject(err);
  }
);

api.interceptors.response.use(
  res => res,
  err => {
    if (err?.response?.status === 401) {
      logout();
    }
    return Promise.reject(err);
  }
);

export default api;
